import clsx from "clsx";
import React from "react";
import { BoxProps, Box, Typography, Collapse } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { parseWorkoutResultValueJsonToWorkoutSection } from "../workout/utils";

import {
  ActivityDto,
  WorkoutExerciseResultDto,
} from "@growth-machine-llc/stridist-api-client";
import { useExerciseHistoryNavigation } from "../coach-clients/hooks/useExerciseHistoryNavigation";
import { ExerciseHistoryItem } from "../client-workouts/ExerciseHistoryItem";
import { WORKOUT_SECTION_ATTR } from "../client-workouts/TitleWithSuperset";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
  },

  setsContainer: {
    maxWidth: 560,
    marginTop: theme.spacing(1),
  },

  title: {
    fontSize: 16,
    fontWeight: "bold",
    paddingBottom: theme.spacing(1),
  },
}));

export interface ActivityWorkoutResponseProps extends BoxProps {
  workoutExerciseResult: WorkoutExerciseResultDto;
  handleOpenVideo?: (url) => void;
  activity?: ActivityDto;
  hideMedia?: boolean;
}

export function ActivityWorkoutResponse({
  workoutExerciseResult,
  className,
  handleOpenVideo,
  activity,
  hideMedia,
  ...other
}: ActivityWorkoutResponseProps) {
  const { title, exercises } = parseWorkoutResultValueJsonToWorkoutSection(
    workoutExerciseResult.value,
  );

  const s = useStyles();
  const username = activity?.client?.username;

  const { handleExerciseSelect } = useExerciseHistoryNavigation(username);

  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      className={clsx(s.root, s.setsContainer, className)}
      {...other}
      {...{ [WORKOUT_SECTION_ATTR]: "true" }}
    >
      {title && (
        <Typography className={s.title} sx={{ pb: 2 }}>
          {title}
        </Typography>
      )}

      <Collapse in={open} timeout={400} unmountOnExit>
        <Box>
          {exercises.map((exercise, index) => (
            <ExerciseHistoryItem
              key={exercise.id}
              exercise={exercise}
              exIndex={index}
              allExercises={exercises}
              handleExerciseSelect={handleExerciseSelect}
            />
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}
